/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_Add_Job_DescInputs */

const en_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a job posting URL or description to start tailoring your application.`)
};

const de_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine Stellenanzeigen-URL oder -Beschreibung hinzu, um mit der Anpassung deiner Bewerbung zu beginnen.`)
};

const fr_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colle l'URL ou la description d'une offre d'emploi pour commencer à personnaliser ta candidature.`)
};

const es_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue la URL o descripción de una oferta de empleo para empezar a personalizar su solicitud.`)
};

const it_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un URL o una descrizione di un'offerta di lavoro per iniziare a personalizzare la tua candidatura.`)
};

const nl_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een vacature-URL of beschrijving om te beginnen met het aanpassen van je sollicitatie.`)
};

const pl_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej adres URL lub opis ogłoszenia o pracę, aby rozpocząć dostosowywanie aplikacji.`)
};

const fi_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liitä työpaikkailmoituksen URL-osoite tai kuvaus aloittaaksesi hakemuksen mukauttamisen.`)
};

const da_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsæt en jobopslag URL eller beskrivelse for at begynde at tilpasse din ansøgning.`)
};

const sv_dashboard_action_add_job_desc = /** @type {(inputs: Dashboard_Action_Add_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klistra in en jobbannons-URL eller beskrivning för att börja anpassa din ansökan.`)
};

/**
* | output |
* | --- |
* | "Paste a job posting URL or description to start tailoring your application." |
*
* @param {Dashboard_Action_Add_Job_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_add_job_desc = /** @type {((inputs?: Dashboard_Action_Add_Job_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_Add_Job_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_add_job_desc(inputs)
	if (locale === "fr") return fr_dashboard_action_add_job_desc(inputs)
	if (locale === "es") return es_dashboard_action_add_job_desc(inputs)
	if (locale === "it") return it_dashboard_action_add_job_desc(inputs)
	if (locale === "nl") return nl_dashboard_action_add_job_desc(inputs)
	if (locale === "pl") return pl_dashboard_action_add_job_desc(inputs)
	if (locale === "fi") return fi_dashboard_action_add_job_desc(inputs)
	if (locale === "da") return da_dashboard_action_add_job_desc(inputs)
	if (locale === "sv") return sv_dashboard_action_add_job_desc(inputs)
	return en_dashboard_action_add_job_desc(inputs)
});